/**
 * Fixup links to my public Profile page to go to MyProfile page.
 * @param {string} profileUrl
 * @param {string} myProfileUrl
 */
function fixupProfileLinks (profileUrl, myProfileUrl) {
    if (getCookie("memberOid")) {
        Foundation.documentReady.then(function () {
            var myOid = getCookie("memberOid");
            $$('a[href^="' + profileUrl + '"]').each(function (a) {
                if (a.href.match(new RegExp("Profile\\?oid=(?:oid(?:%3A|:)?)?" + myOid + "$"))) {
                    a.href = myProfileUrl;
                }
            });
        });
    }
}

// ---------------------------------------------------------------------

window["fixupProfileLinks"] = fixupProfileLinks;

// ---------------------------------------------------------------------
